export enum ActionTypes {
  SET_USER = "SET_USER",
  SET_SCORE = "SET_SCORE",
  SET_THEATER = "SET_THEATER",
  SET_LOADING = "SET_LOADING",
  SET_MODAL = "SET_MODAL",
  CLOSE_MODAL = "CLOSE_MODAL",
  SELECT_CHARACTER = "SELECT_CHARACTER",
  DESELECT_CHARACTER = "DESELECT_CHARACTER",
  SET_SQUAD_SUBMISSION = "SET_SQUAD_SUBMISSION",
}
